var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoButtonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3223,
    cy: 10,
    r: 7,
    fill: "#DEE2E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42979 6.99694C9.41883 7.45682 9.76944 7.82935 10.2954 7.82935C10.8432 7.82935 11.1935 7.45682 11.1938 6.99694C11.1826 6.51515 10.8429 6.15357 10.306 6.15357C9.76945 6.15357 9.41883 6.51484 9.42979 6.99694Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2246 13.0423C11.2246 13.5466 10.8158 13.9554 10.3115 13.9554C9.80719 13.9554 9.39844 13.5466 9.39844 13.0423V9.39008C9.39844 8.88576 9.80719 8.47701 10.3115 8.47701C10.8158 8.47701 11.2246 8.88576 11.2246 9.39008V13.0423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoButtonWhite);
export default __webpack_public_path__ + "static/media/info-button-white.518eb11f5683f936f898e308a3200324.svg";
export { ForwardRef as ReactComponent };